import { Box, Center, Flex } from "@chakra-ui/react";
import { KanbanIcon } from "components/vectors/kanban-icon";
import { useAttendanceKanbanContext } from "../kanban-and-table-atendimento/kanban/kanban-context";
import { VisualizationMode } from "../kanban-and-table-atendimento/kanban/parts/types";
import { use3cPlusContext } from "contexts/Context3cPlus";
import { WhatsAppIcon } from "components/vectors/whatsapp-icons";
import { MultiSelector } from "components/multi-selector";

export function VisualizationModeSwitch() {
  const { controls3cPlus } = use3cPlusContext();
  const {
    getAllColumnAttendances: getAttendances,
    setVisualizationMode,
    visualizationMode,
  } = useAttendanceKanbanContext();

  const onChangeKanbanEnabled = (state: VisualizationMode) => {
    setVisualizationMode(state);
    if (state === "kanban") getAttendances();
  };

  return (
    <MultiSelector
      options={options}
      onChange={(option) => {
        onChangeKanbanEnabled(option.value);
      }}
      value={visualizationMode}
      containerProps={{ h: "32px" }}
    />
  );
}

const options = [
  {
    name: (
      <>
        <KanbanIcon display="block" mr="4px" /> Funil
      </>
    ),
    value: "kanban",
  },
  {
    name: (
      <>
        <WhatsAppIcon
          color={"currentColor"}
          width="15px"
          height="17px"
          display="block"
          mr="4px"
        />
        Chat
      </>
    ),
    value: "whats-app-attendances",
  },
];
